module.exports = __webpack_public_path__ + "img/dr-consultation.13c646fc.gif";